import i18n from '@/plugins/i18n'
/* import routeHelpers from '@/router/routeHelpers' */
import { PATIENT_ROLE, PROFESSIONAL_ROLE } from '@/constants/roles'

const routes = [
  {
    path: '/',
    name: 'Video',
    component: () => import('@/components/video-launcher/Start'),
    meta: {
      title: {
        text () {
          return i18n.t('videoSession')
        }
      },
      roles: [PATIENT_ROLE, PROFESSIONAL_ROLE]
    }
  },
  {
    path: 'test',
    name: 'Test',
    component: () => import('@/components/video-launcher/Test'),
    meta: {
      title: {
        text () {
          return i18n.t('dialog-title-videoTest')
        }
      }
    }
  },
  {
    path: 'test/:token',
    name: 'TestToken',
    component: () => import('@/components/video-launcher/Test'),
    meta: {
      title: {
        text () {
          return i18n.t('dialog-title-videoTest')
        }
      }
    }
  },
  {
    path: 'error',
    name: 'Error',
    component: () => import('@/components/video-launcher/Error'),
    meta: {
      title: {
        text: 'Error'
      }
    }
  },
  {
    path: 'support-chat',
    name: 'SupportChatVideo',
    component: () => import('@/components/public/HubspotChat'),
    meta: {
      title: {
        text () {
          return i18n.t('support-chat')
        }
      }
    }
  },
  {
    path: ':token',
    name: 'VideoToken',
    component: () => import('@/components/video-launcher/Video'),
    meta: {
      title: {
        text () {
          return i18n.t('videoSession')
        }
      }
    }
  }
]

routes.forEach(o => o.meta.footer = { disabled: true })

export default routes




// WEBPACK FOOTER //
// ./src/router/routes/video.routes.js